<h1>Subscriptions</h1>
<div class="contentDiv">
    <app-subscriptions-consolepage></app-subscriptions-consolepage>
</div>